import fp from 'lodash/fp'
import { combine, withEffect } from 'react-hooks-combine'
import { withRouter } from 'react-router-dom'

import LayoutComponent from './component'

export default combine({
  hocs: [withRouter],
  transformPropsBefore: ({ location, ...rest }) => {
    const skipRoutes = [
      'signup',
      'login',
      'reset',
      'user-data-deletion-request',
    ]
    const isHeaderFooterHidden = skipRoutes.some((skippedItem) =>
      location.pathname.includes(skippedItem)
    )

    return {
      location,
      isHeaderFooterHidden,
      ...rest,
    }
  },
  hooks: [
    withEffect((_store, { history }) => {
      const innerView = document.querySelector('#inner-view')
      // IE compatibility fixes
      const scrollInner = fp.hasIn('scrollTo', innerView)
        ? innerView.scrollTo.bind(innerView)
        : fp.noop

      return history.listen(() => {
        scrollInner(0, 0)
      })
    }, []),
  ],
})(LayoutComponent)
